export function prepareFileName(file: File) {
  const name = file.name.replace(/\s+/g, "_").replace(/[:\\/]+/g, "");
  return renameFile(file, name);
}

export function omitDuplicateName(file: File, files: File[]) {
  if (files.some((f) => f.name === file.name)) {
    const extensionStart = file.name.lastIndexOf(".");
    const fileExtension = file.name.slice(extensionStart);
    const fileName = file.name.slice(0, extensionStart);

    const lastCopyNumber = files
      .filter((f) =>
        new RegExp(
          `^${fileName}( \\(\\d+\\))${fileExtension.replace(/\./g, "\\.")}$`
        ).test(f.name)
      )
      .reduce((prev, f) => {
        const copyNumber = Number(
          f.name.slice(
            fileName.length + 2,
            f.name.length - fileExtension.length - 1
          )
        );

        return Math.max(prev, copyNumber);
      }, 0);

    return renameFile(
      file,
      `${fileName} (${lastCopyNumber + 1})${fileExtension}`
    );
  }
  return file;
}

export function renameFile(file: File, name: string) {
  return new File([file], name, {
    type: file.type,
    lastModified: file.lastModified,
  });
}
